module.exports = __webpack_public_path__ + "37ba7b92/img/send-icon.3cfb6275.svg";